/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarImageDTO } from '../models/CarImageDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomCarImageResourceService {
    /**
     * @returns CarImageDTO OK
     * @throws ApiError
     */
    public static createCarImage({
        carId,
        requestBody,
    }: {
        /**
         * The id of the car to add image
         */
        carId: number,
        requestBody: CarImageDTO,
    }): CancelablePromise<CarImageDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/custom/car_image/addImageToCar/{carId}',
            path: {
                'carId': carId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the car image dto requested
     * Retrieves the car image dto requested
     * @returns CarImageDTO OK
     * @throws ApiError
     */
    public static getImage({
        imageId,
    }: {
        /**
         * The id of the car's image requested
         */
        imageId: number,
    }): CancelablePromise<CarImageDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/car_image/{imageId}',
            path: {
                'imageId': imageId,
            },
        });
    }
    /**
     * Get a list of all car images
     * Retrieves a list of all car images
     * @returns CarImageDTO OK
     * @throws ApiError
     */
    public static getAllCarImages({
        carId,
    }: {
        /**
         * The id of the car to filter images
         */
        carId: number,
    }): CancelablePromise<Array<CarImageDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/car_image/allCarImages/{carId}',
            path: {
                'carId': carId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteImage({
        id,
    }: {
        /**
         * The id of the car image to delete
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/car_image/deleteImage/{id}',
            path: {
                'id': id,
            },
        });
    }
}
